// import { useState, useEffect, useRef, useCallback, useMemo } from "react";
// import "./Productstwo.scss";
// import { useCollection } from "../../firebase-files/hooks/useCollection";
// import { useDocument } from "../../firebase-files/hooks/useDocument";
// import { FaRegHeart, FaStar } from "react-icons/fa";
// import {
//   IoArrowForward,
//   IoArrowBack,
//   IoFilter,
//   IoClose,
// } from "react-icons/io5";
// import PriceRangeSlider from "./PriceRangeSlider";
// import useCart from "../../firebase-files/hooks/useCart";
// import { Link } from "react-router-dom";
// import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
// import useWishlist from "../../firebase-files/hooks/useWishlist"; // Import useWishlist
// import CustomSnackbar from "../CustomSnackbar"; // Import CustomSnackbar
// import PGLoaders from "../../default-pages/PGLoaders/PGLoaders";
// import AddProductsTwo from "../AddProductsTwo";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import VendorLocations from "../VendorLocations";

// const Productstwo = () => {
//   const { user } = useAuthContext();
//   const isAdminOrSuperAdmin =
//     user?.role === "admin" || user?.role === "superAdmin";

//   const navigate = useNavigate();
//   const { documents: products } = useCollection("products");
//   const { documents: categories } = useCollection("m_categories");
//   const { document: currencyDoc } = useDocument("settings", "currency");
//   const { document: multiLocation } = useDocument("settings", "multiLocation");
//   const { document: productDetailsVisibility } = useDocument(
//     "settings",
//     "productDetailsVisibility"
//   );

//   const { document: TAXDocument } = useDocument("settings", "tax_GST");

//   const { document: dbAppTypeDocuments } = useDocument("settings", "AppType");

//   const isAdmin = user?.role === "admin";
//   const isSuperAdmin = user && user.role === "superAdmin";
//   // Add cart functionality
//   const { cartItems, addToCart, updateCartItemQuantity } = useCart();
//   // Add wishlist functionality
//   const { wishlistItems, addToWishlist, removeFromWishlist } = useWishlist();
//   const { document: pageControlDoc } = useDocument("settings", "pagesControl");

//   // State management
//   const [searchParams, setSearchParams] = useSearchParams();
//   const [productsData, setProductsData] = useState([]);
//   const [categoriesData, setCategoriesData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showFilters, setShowFilters] = useState(false);
//   const [visibleProducts, setVisibleProducts] = useState(10);
//   const [searchQuery, setSearchQuery] = useState("");

//   // Selected location stored in localStorage (fallback to user if missing)
//   const [selectedLocation, setSelectedLocation] = useState(() => {
//     return (
//       localStorage.getItem("selectedLocation") ||
//       user?.selectedLocation ||
//       "all"
//     );
//   });

//   const [filters, setFilters] = useState({
//     minPrice: "",
//     maxPrice: "",
//     selectedCategories: [],
//     selectedSubCategories: [],
//     sortBy: "default",
//     selectedRatings: [],
//   });

//   useEffect(() => {
//     const params = Object.fromEntries(searchParams.entries());

//     // categories from URL (if any)
//     const selectedCategoriesFromParams = params.category
//       ? params.category
//           .split(",")
//           .map((c) => decodeURIComponent(c).toLowerCase())
//       : [];

//     // subcategories from URL: expect "category|subcategory" pairs
//     const selectedSubCategoriesFromParams = params.subcategory
//       ? params.subcategory.split(",").map((pair) => {
//           const parts = pair.split("|");
//           const categoryPart = parts[0]
//             ? decodeURIComponent(parts[0]).toLowerCase()
//             : "";
//           const subPart = parts[1]
//             ? decodeURIComponent(parts[1]).toLowerCase()
//             : decodeURIComponent(parts[0] || "").toLowerCase();
//           // if URL had only subcategory (old style), subPart will be the subcategory and categoryPart may be ""
//           return { category: categoryPart, subcategory: subPart };
//         })
//       : [];

//     // ensure categories includes ones implied by subcategories (so UI expands)
//     selectedSubCategoriesFromParams.forEach(({ category }) => {
//       if (category && !selectedCategoriesFromParams.includes(category)) {
//         selectedCategoriesFromParams.push(category);
//       }
//     });
//     const newFilters = {
//       minPrice: params.minPrice || "",
//       maxPrice: params.maxPrice || "",
//       selectedCategories: selectedCategoriesFromParams,
//       selectedSubCategories: selectedSubCategoriesFromParams,
//       sortBy: params.sortBy || "default",
//       selectedRatings: params.rating
//         ? params.rating.split(",").map(Number)
//         : [],
//     };

//     setFilters(newFilters);
//   }, [searchParams]);

//   const [layoutType, setLayoutType] = useState("grid"); // 'grid' or 'list'
//   const [activeImageIndexes, setActiveImageIndexes] = useState({});
//   const [currency, setCurrency] = useState(currencyDoc);
//   const [openAccordions, setOpenAccordions] = useState({
//     priceRange: true,
//     categories: true,
//     rating: true,
//   });
//   // Add a state to trigger price slider reset
//   const [resetTrigger, setResetTrigger] = useState(0);

//   // Snackbar state
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   // Replace visibleProducts state with a page state
//   const [page, setPage] = useState(1);
//   const [isLoading, setIsLoading] = useState(false);
//   const [hasMore, setHasMore] = useState(true);
//   const PRODUCTS_PER_PAGE = 10;

//   // Move getFilteredProducts function before using it in useMemo
//   const getFilteredProducts = () => {
//     let filtered = [...productsData];

//     // 🔐 ROLE-BASED STATUS FILTER
//     if (!isAdminOrSuperAdmin) {
//       filtered = filtered.filter((product) => product.status === "active");
//     }

//     // ⭐ LOCATION FILTER ⭐
//     if (multiLocation?.isEnabled === false) {
//       return filtered;
//     }

//     if (selectedLocation === "all") {
//       return filtered;
//     }

//     if (multiLocation?.isEnabled === true && selectedLocation) {
//       filtered = filtered.filter((product) => {
//         const showTo = product.showProductTo;
//         if (!showTo || showTo.length === 0) return false;
//         if (showTo.includes("all")) return true;
//         return showTo.includes(selectedLocation);
//       });
//     }

//     // 🔍 Search
//     if (searchQuery) {
//       filtered = filtered.filter((product) =>
//         product.name.toLowerCase().includes(searchQuery.toLowerCase())
//       );
//     }

//     // 💰 Price filter
//     if (filters.minPrice) {
//       filtered = filtered.filter(
//         (product) => product.price >= Number(filters.minPrice)
//       );
//     }

//     if (filters.maxPrice) {
//       filtered = filtered.filter(
//         (product) => product.price <= Number(filters.maxPrice)
//       );
//     }

//     // 📂 Category & Subcategory
//     if (
//       filters.selectedCategories.length ||
//       filters.selectedSubCategories.length
//     ) {
//       filtered = filtered.filter((product) => {
//         const productCategories = product.category.map((c) => c.toLowerCase());

//         const categoryMatch =
//           filters.selectedCategories.length === 0 ||
//           productCategories.some((cat) =>
//             filters.selectedCategories.includes(cat)
//           );

//         if (filters.selectedSubCategories.length === 0) {
//           return categoryMatch;
//         }

//         const subCategoryMatch = filters.selectedSubCategories.some(
//           ({ subcategory }) =>
//             product.subCategory
//               .map((s) => s.toLowerCase())
//               .includes(subcategory)
//         );

//         return categoryMatch && subCategoryMatch;
//       });
//     }

//     // ⭐ Rating
//     if (filters.selectedRatings.length > 0) {
//       filtered = filtered.filter((product) =>
//         filters.selectedRatings.some((minRating) => product.rating >= minRating)
//       );
//     }

//     // 🔀 Sorting
//     switch (filters.sortBy) {
//       case "price-asc":
//         filtered.sort((a, b) => a.price - b.price);
//         break;
//       case "price-desc":
//         filtered.sort((a, b) => b.price - a.price);
//         break;
//       default:
//         break;
//     }

//     return filtered;
//   };

//   // Create a ref for our observer
//   const observer = useRef();

//   // Now use getFilteredProducts in useMemo
//   const filteredProducts = useMemo(
//     () => getFilteredProducts(),
//     [
//       productsData,
//       searchQuery,
//       selectedLocation,
//       filters.minPrice,
//       filters.maxPrice,
//       filters.selectedCategories,
//       filters.selectedSubCategories,
//       filters.selectedRatings,
//       filters.sortBy,
//     ]
//   );

//   // Add back the paginated products logic
//   const paginatedProducts = useMemo(() => {
//     return filteredProducts.slice(0, page * PRODUCTS_PER_PAGE);
//   }, [filteredProducts, page]);

//   // Update hasMore whenever filtered products or page changes
//   useEffect(() => {
//     const totalPages = Math.ceil(filteredProducts.length / PRODUCTS_PER_PAGE);
//     setHasMore(page < totalPages);
//   }, [filteredProducts.length, page]);

//   // Intersection Observer callback
//   const lastProductRef = useCallback(
//     (node) => {
//       if (isLoading || !node) return;

//       if (observer.current) {
//         observer.current.disconnect();
//       }

//       observer.current = new IntersectionObserver((entries) => {
//         if (entries[0].isIntersecting && hasMore) {
//           setIsLoading(true);
//           // Simulate loading delay
//           setTimeout(() => {
//             setPage((prevPage) => prevPage + 1);
//             setIsLoading(false);
//           }, 500);
//         }
//       });

//       observer.current.observe(node);
//     },
//     [isLoading, hasMore]
//   );

//   // Clean up observer on unmount
//   useEffect(() => {
//     const currentObserver = observer.current;
//     return () => {
//       if (currentObserver) {
//         currentObserver.disconnect();
//       }
//     };
//   }, []);

//   // Initialize data
//   useEffect(() => {
//     if (!products || !categories || !currencyDoc) {
//       setLoading(true);
//     }
//     if (products && categories && currencyDoc) {
//       setProductsData(products);
//       setCategoriesData(categories);
//       setCurrency(currencyDoc);
//       setLoading(false);
//     }
//   }, [products, categories, currencyDoc]);

//   // Keep selectedLocation in sync when other tab/component updates it
//   useEffect(() => {
//     const handleStorage = (e) => {
//       if (e.key === "selectedLocation") {
//         setSelectedLocation(e.newValue);
//       }
//     };
//     window.addEventListener("storage", handleStorage);
//     return () => window.removeEventListener("storage", handleStorage);
//   }, []);

//   useEffect(() => {
//     const updateLocation = () => {
//       const newLocation = localStorage.getItem("selectedLocation") || "all";
//       setSelectedLocation(newLocation);
//     };

//     window.addEventListener("selectedLocationChanged", updateLocation);

//     return () => {
//       window.removeEventListener("selectedLocationChanged", updateLocation);
//     };
//   }, []);

//   const getFilteredAndPaginatedProducts = () => {
//     const filtered = getFilteredProducts();
//     const totalPages = Math.ceil(filtered.length / PRODUCTS_PER_PAGE);
//     setHasMore(page < totalPages);
//     return filtered.slice(0, page * PRODUCTS_PER_PAGE);
//   };

//   const handleLoadMore = () => {
//     setVisibleProducts((prev) => prev + 10);
//   };

//   const toggleFilters = () => {
//     setShowFilters(!showFilters);
//     // Toggle body scroll
//     document.body.style.overflow = !showFilters ? "hidden" : "";
//   };

//   const handleFilterChange = useCallback(
//     (type, value) => {
//       setFilters((prev) => {
//         if (prev[type] === value) return prev;
//         const updatedFilters = { ...prev, [type]: value };

//         const params = new URLSearchParams();

//         if (updatedFilters.minPrice)
//           params.set("minPrice", updatedFilters.minPrice);
//         if (updatedFilters.maxPrice)
//           params.set("maxPrice", updatedFilters.maxPrice);

//         if (updatedFilters.selectedCategories.length > 0)
//           params.set(
//             "category",
//             updatedFilters.selectedCategories
//               .map((c) => encodeURIComponent(c))
//               .join(",")
//           );

//         if (updatedFilters.selectedSubCategories.length > 0)
//           params.set(
//             "subcategory",
//             updatedFilters.selectedSubCategories
//               .map(
//                 (s) =>
//                   `${encodeURIComponent(s.category)}|${encodeURIComponent(
//                     s.subcategory
//                   )}`
//               )
//               .join(",")
//           );

//         if (updatedFilters.selectedRatings.length > 0)
//           params.set("rating", updatedFilters.selectedRatings.join(","));

//         if (updatedFilters.sortBy && updatedFilters.sortBy !== "default")
//           params.set("sortBy", updatedFilters.sortBy);

//         setSearchParams(params);
//         return updatedFilters;
//       });
//     },
//     [setSearchParams]
//   );

//   // Handles Subcategory checkbox updates and URL sync
//   const handleSubCategoryChange = (category, subcategory, checked) => {
//     setFilters((prev) => {
//       const newSubCategories = checked
//         ? [
//             ...prev.selectedSubCategories,
//             {
//               category: category.toLowerCase(),
//               subcategory: subcategory.toLowerCase(),
//             },
//           ]
//         : prev.selectedSubCategories.filter(
//             (item) =>
//               !(
//                 item.category === category.toLowerCase() &&
//                 item.subcategory === subcategory.toLowerCase()
//               )
//           );

//       const updatedFilters = {
//         ...prev,
//         selectedSubCategories: newSubCategories,
//       };

//       // URL params
//       const params = new URLSearchParams();
//       if (updatedFilters.minPrice)
//         params.set("minPrice", updatedFilters.minPrice);
//       if (updatedFilters.maxPrice)
//         params.set("maxPrice", updatedFilters.maxPrice);
//       if (updatedFilters.selectedCategories.length > 0)
//         params.set(
//           "category",
//           updatedFilters.selectedCategories
//             .map((c) => encodeURIComponent(c))
//             .join(",")
//         );
//       if (newSubCategories.length > 0)
//         params.set(
//           "subcategory",
//           newSubCategories
//             .map(
//               (s) =>
//                 `${encodeURIComponent(s.category)}|${encodeURIComponent(
//                   s.subcategory
//                 )}`
//             )
//             .join(",")
//         );
//       if (updatedFilters.selectedRatings.length > 0)
//         params.set("rating", updatedFilters.selectedRatings.join(","));
//       if (updatedFilters.sortBy && updatedFilters.sortBy !== "default")
//         params.set("sortBy", updatedFilters.sortBy);

//       setSearchParams(params);
//       return updatedFilters;
//     });
//   };

//   const nextImage = (productId, totalImages) => {
//     setActiveImageIndexes((prev) => ({
//       ...prev,
//       [productId]: (prev[productId] + 1) % totalImages,
//     }));
//   };

//   const prevImage = (productId, totalImages) => {
//     setActiveImageIndexes((prev) => ({
//       ...prev,
//       [productId]: (prev[productId] - 1 + totalImages) % totalImages,
//     }));
//   };

//   const toggleAccordion = (section) => {
//     setOpenAccordions((prev) => ({
//       ...prev,
//       [section]: !prev[section],
//     }));
//   };

//   // Add cart functionality
//   const isProductInCart = (productId) => {
//     return cartItems.some((item) => item.productId === productId);
//   };

//   const findCartItem = (productId) => {
//     return cartItems.find((item) => item.productId === productId);
//   };

//   const handleAddToCart = async (productId) => {
//     try {
//       await addToCart(productId);
//     } catch (error) {
//       // setSnackbar({
//       //     open: true,
//       //     message: error.message,
//       //     severity: "error",
//       // });
//     }
//   };

//   const handleIncrementQuantity = async (cartItem) => {
//     try {
//       await updateCartItemQuantity(cartItem.id, cartItem.quantity + 1);
//     } catch (error) {
//       // setSnackbar({
//       //     open: true,
//       //     message: error.message,
//       //     severity: "error",
//       // });
//     }
//   };

//   const handleDecrementQuantity = async (cartItem, removeItem = false) => {
//     try {
//       if (removeItem || cartItem.quantity <= 1) {
//         await updateCartItemQuantity(cartItem.id, 0); // This will remove the item
//       } else {
//         await updateCartItemQuantity(cartItem.id, cartItem.quantity - 1);
//       }
//     } catch (error) {
//       // setSnackbar({
//       //     open: true,
//       //     message: error.message,
//       //     severity: "error",
//       // });
//     }
//   };

//   const isOutOfStock = (product) => {
//     return product.stock <= 0;
//   };

//   const handleProductCardClick = (productId) => {
//     navigate(`/product-details-two/${productId}`);
//   };

//   // Add rating options
//   const ratingOptions = [
//     { value: 4.5, label: "4.5 & up" },
//     { value: 4.0, label: "4.0 & up" },
//     { value: 3.0, label: "3.0 & up" },
//   ];

//   // Add this helper function to check if any filters are active
//   const areFiltersActive = () => {
//     return (
//       (filters.minPrice !== "" && filters.minPrice !== "0") ||
//       (filters.maxPrice !== "" && filters.maxPrice !== "5000") ||
//       filters.selectedCategories.length > 0 ||
//       filters.selectedSubCategories.length > 0 ||
//       filters.selectedRatings.length > 0 ||
//       filters.sortBy !== "default"
//     );
//   };

//   // Add this function to reset all filters
//   const handleResetFilters = () => {
//     setFilters({
//       minPrice: "",
//       maxPrice: "",
//       selectedCategories: [],
//       selectedSubCategories: [],
//       sortBy: "default",
//       selectedRatings: [],
//     });
//     setSearchParams({});
//   };

//   // Add loading spinner component
//   const LoadingSpinner = () => (
//     <div className="loading-spinner">
//       <div className="spinner"></div>
//     </div>
//   );

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbar({ ...snackbar, open: false });
//   };

//   // Add wishlist functionality
//   const isProductInWishlist = (productId) => {
//     return wishlistItems.some((item) => item.productId === productId);
//   };

//   const handleToggleWishlist = async (e, productId) => {
//     e.stopPropagation(); // Prevent card click
//     if (!user) {
//       setSnackbar({
//         open: true,
//         message: "Please login to add items to wishlist.",
//         severity: "info",
//       });
//       return;
//     }

//     if (isProductInWishlist(productId)) {
//       const wishlistItem = wishlistItems.find(
//         (item) => item.productId === productId
//       );
//       await removeFromWishlist(wishlistItem.id);
//       setSnackbar({
//         open: true,
//         message: "Product removed from wishlist!",
//         severity: "success",
//       });
//     } else {
//       await addToWishlist(productId);
//       setSnackbar({
//         open: true,
//         message: "Product added to wishlist!",
//         severity: "success",
//       });
//     }
//   };

//   if (loading) {
//     return <div className="loading"></div>;
//   }

//   return (
//     <div className="products-two-container">
//       {/* Add overlay */}
//       <div
//         className={`drawer-overlay ${showFilters ? "show" : ""}`}
//         onClick={toggleFilters}
//       ></div>
//       <div className="two-column-layout">
//         {/* Left Column - Filters */}
//         <aside className={`filters-column ${showFilters ? "show" : ""}`}>
//           <div className="filters-header">
//             <div className="filters-title-reset">
//               <h3>Filters</h3>
//               {areFiltersActive() && (
//                 <button
//                   className="reset-product-two-filters-btn"
//                   onClick={handleResetFilters}
//                   title="Reset all filters"
//                 >
//                   Reset
//                 </button>
//               )}
//             </div>
//             <button
//               className="close-filters"
//               onClick={toggleFilters}
//               aria-label="Close filters"
//             >
//               <span className="material-symbols-outlined">
//                 <IoClose />
//               </span>
//             </button>
//           </div>
//           <div className="filters-content">
//             <div className="filter-section">
//               <div
//                 className={`accordion-header ${
//                   openAccordions.priceRange ? "open" : ""
//                 }`}
//                 onClick={() => toggleAccordion("priceRange")}
//               >
//                 <h3>Price Range</h3>
//                 <span className="material-symbols-outlined">expand_more</span>
//               </div>
//               <div
//                 className={`accordion-content ${
//                   openAccordions.priceRange ? "open" : ""
//                 }`}
//               >
//                 <PriceRangeSlider
//                   minPrice={filters.minPrice}
//                   maxPrice={filters.maxPrice}
//                   onChange={({ min, max }) => {
//                     handleFilterChange("minPrice", min);
//                     handleFilterChange("maxPrice", max);
//                   }}
//                   currency={currency}
//                   resetTrigger={resetTrigger} // Add this prop
//                 />
//               </div>
//             </div>

//             <hr />

//             {/* START CAT/SUBCAT FILTERS */}
//             <div className="filter-section">
//               <div
//                 className={`accordion-header ${
//                   openAccordions.categories ? "open" : ""
//                 }`}
//                 onClick={() => toggleAccordion("categories")}
//               >
//                 <h3>Categories</h3>
//                 <span className="material-symbols-outlined">
//                   {openAccordions.categories ? "expand_less" : "expand_more"}
//                 </span>
//               </div>
//               <div
//                 className={`accordion-content ${
//                   openAccordions.categories ? "open" : ""
//                 }`}
//               >
//                 {categoriesData
//                   .filter(
//                     (category) =>
//                       category.status === "active" &&
//                       category.source?.toLowerCase() !== "faq" // ✅ exclude FAQ source
//                   )
//                   .map((category) => (
//                     <div
//                       key={category.category}
//                       className="product-two-category-item"
//                     >
//                       <label className="checkbox-label">
//                         <input
//                           type="checkbox"
//                           checked={filters.selectedCategories.includes(
//                             category.category.toLowerCase()
//                           )}
//                           onChange={(e) => {
//                             const newCategories = e.target.checked
//                               ? [
//                                   ...filters.selectedCategories,
//                                   category.category.toLowerCase(),
//                                 ]
//                               : filters.selectedCategories.filter(
//                                   (cat) =>
//                                     cat !== category.category.toLowerCase()
//                                 );

//                             // Clear subcategories of this category when unchecked
//                             const newSubCategories = e.target.checked
//                               ? filters.selectedSubCategories
//                               : filters.selectedSubCategories.filter(
//                                   ({ category: cat }) =>
//                                     cat !== category.category.toLowerCase()
//                                 );

//                             handleFilterChange(
//                               "selectedCategories",
//                               newCategories
//                             );
//                             handleFilterChange(
//                               "selectedSubCategories",
//                               newSubCategories
//                             );
//                           }}
//                         />
//                         <span className="product-two-category-name">
//                           {category.category}
//                         </span>
//                       </label>

//                       {/* Subcategories */}
//                       {filters.selectedCategories.includes(
//                         category.category.toLowerCase()
//                       ) &&
//                         category.subCategories &&
//                         category.subCategories
//                           .filter(
//                             (sub) =>
//                               sub.status === "active" &&
//                               sub.source?.toLowerCase() !== "faq" // ✅ exclude FAQ subcategories
//                           )
//                           .map((subcategory) => (
//                             <label
//                               key={subcategory.subCategoryName}
//                               className="checkbox-label subcategory-label subcategories-list"
//                             >
//                               <input
//                                 type="checkbox"
//                                 checked={filters.selectedSubCategories.some(
//                                   ({ category: cat, subcategory: sub }) =>
//                                     cat === category.category.toLowerCase() &&
//                                     sub ===
//                                       subcategory.subCategoryName.toLowerCase()
//                                 )}
//                                 onChange={(e) => {
//                                   const newSubCategories = e.target.checked
//                                     ? [
//                                         ...filters.selectedSubCategories,
//                                         {
//                                           category:
//                                             category.category.toLowerCase(),
//                                           subcategory:
//                                             subcategory.subCategoryName.toLowerCase(),
//                                         },
//                                       ]
//                                     : filters.selectedSubCategories.filter(
//                                         ({ category: cat, subcategory: sub }) =>
//                                           !(
//                                             cat ===
//                                               category.category.toLowerCase() &&
//                                             sub ===
//                                               subcategory.subCategoryName.toLowerCase()
//                                           )
//                                       );
//                                   handleFilterChange(
//                                     "selectedSubCategories",
//                                     newSubCategories
//                                   );
//                                 }}
//                               />
//                               <span className="product-two-subcategory-name">
//                                 {subcategory.subCategoryName}
//                               </span>
//                             </label>
//                           ))}
//                     </div>
//                   ))}
//               </div>
//             </div>
//             {/* END CAT/SUBCAT FILTERS */}

//             <hr />

//             <div className="filter-section">
//               <div
//                 className={`accordion-header ${
//                   openAccordions.rating ? "open" : ""
//                 }`}
//                 onClick={() => toggleAccordion("rating")}
//               >
//                 <h3>Rating</h3>
//                 <span className="material-symbols-outlined">
//                   {openAccordions.rating ? "expand_less" : "expand_more"}
//                 </span>
//               </div>
//               <div
//                 className={`accordion-content ${
//                   openAccordions.rating ? "open" : ""
//                 }`}
//               >
//                 <div className="rating-section">
//                   {ratingOptions.map((option) => (
//                     <label key={option.value} className="checkbox-label">
//                       <input
//                         type="checkbox"
//                         checked={filters.selectedRatings.includes(option.value)}
//                         onChange={(e) => {
//                           const newRatings = e.target.checked
//                             ? [...filters.selectedRatings, option.value]
//                             : filters.selectedRatings.filter(
//                                 (r) => r !== option.value
//                               );
//                           handleFilterChange("selectedRatings", newRatings);
//                         }}
//                       />
//                       <div className="rating-label">
//                         <span>{option.label}</span>
//                         <div className="stars">
//                           {[...Array(5)].map((_, index) => (
//                             <FaStar
//                               key={index}
//                               className={
//                                 index + 1 <= option.value ? "filled" : "empty"
//                               }
//                             />
//                           ))}
//                         </div>
//                       </div>
//                     </label>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             <hr className="filter-divider" />
//           </div>
//         </aside>

//         {/* Right Column - Main Content */}
//         <div className="bb-main-column">
//           <div className="bb-products-section">
//             <div className="bb-products-header">
//               <VendorLocations />
//               <div className="view-options">
//                 {/* <button
//                                     className={`layout-toggle ${layoutType === 'grid' ? 'active' : ''}`}
//                                     onClick={() => setLayoutType('grid')}
//                                 >
//                                     <span className="material-symbols-outlined">
//                                         grid_view
//                                     </span>
//                                 </button> */}

//                 {/* <button
//                                     className={`layout-toggle ${layoutType === 'list' ? 'active' : ''}`}
//                                     onClick={() => setLayoutType('list')}
//                                 >
//                                     <span className="material-symbols-outlined">
//                                         list
//                                     </span>
//                                 </button> */}

//                 <button
//                   className="filter-toggle"
//                   onClick={toggleFilters}
//                   aria-label="Toggle filters"
//                 >
//                   <IoFilter />
//                 </button>
//               </div>

//               <div className="sort-section">
//                 <select
//                   value={filters.sortBy}
//                   onChange={(e) => handleFilterChange("sortBy", e.target.value)}
//                 >
//                   <option value="default">Sort By</option>
//                   <option value="price-asc">Price: Low to High</option>
//                   <option value="price-desc">Price: High to Low</option>
//                 </select>
//               </div>
//             </div>

//             {filteredProducts.length === 0 ? (
//               <div className="bb-no-products">
//                 <span className="material-symbols-outlined">inventory_2</span>
//                 <h3>No Products Found</h3>
//                 <p>Try adjusting your filters or search criteria</p>
//               </div>
//             ) : (
//               <div className={`product-two-products-container ${layoutType}`}>
//                 {paginatedProducts.map((product, index) => {
//                   const isLastProduct = index === paginatedProducts.length - 1;

//                   return (
//                     <div
//                       ref={isLastProduct ? lastProductRef : null}
//                       key={product.id}
//                       className="product-card"
//                     >
//                       <div
//                         className="card-clickable-overlay"
//                         onClick={() => handleProductCardClick(product.id)}
//                       ></div>
//                       <div className="product-image-container">
//                         <div className="image-carousel">
//                           {product.images && product.images.length > 0 && (
//                             // <img
//                             //   src={
//                             //     product.images[
//                             //       activeImageIndexes[product.id] || 0
//                             //     ]
//                             //   }
//                             //   alt={product.name}
//                             // />
//                             <img
//                               src={(() => {
//                                 const imgs = product.images;

//                                 if (!imgs) return "";

//                                 // case: array of strings or objects
//                                 if (Array.isArray(imgs)) {
//                                   const img =
//                                     imgs[activeImageIndexes[product.id] || 0];
//                                   return typeof img === "string"
//                                     ? img
//                                     : img?.url || "";
//                                 }

//                                 // case: single string
//                                 if (typeof imgs === "string") {
//                                   return imgs;
//                                 }

//                                 // case: single object { url: "..." }
//                                 if (typeof imgs === "object" && imgs.url) {
//                                   return imgs.url;
//                                 }

//                                 return "";
//                               })()}
//                               alt={product.name}
//                             />
//                           )}
//                           {product.images && product.images.length > 1 && (
//                             <>
//                               <button
//                                 className="carousel-btn prev"
//                                 onClick={(e) => {
//                                   e.preventDefault();
//                                   prevImage(product.id, product.images.length);
//                                 }}
//                               >
//                                 <IoArrowBack />
//                               </button>
//                               <button
//                                 className="carousel-btn next"
//                                 onClick={(e) => {
//                                   e.preventDefault();
//                                   nextImage(product.id, product.images.length);
//                                 }}
//                               >
//                                 <IoArrowForward />
//                               </button>
//                             </>
//                           )}
//                         </div>
//                         <button
//                           className={`wishlist-btn ${
//                             isProductInWishlist(product.id) ? "active" : ""
//                           }`}
//                           onClick={(e) => handleToggleWishlist(e, product.id)}
//                         >
//                           <FaRegHeart />
//                         </button>
//                         {product.discount > 0 && (
//                           <div className="discount-badge">
//                             {product.discount}%
//                           </div>
//                         )}
//                       </div>
//                       <div className="product-details">
//                         <div className="product-info">
//                           <div className="product-header">
//                             <div className="product-category">
//                               {product.category?.join(" | ")} |&nbsp;
//                               {product.subCategory?.join(" | ")}
//                             </div>

//                             <h3 className="product-name">{product.name}</h3>

//                             <div className="product-description">
//                               <p>
//                                 {product.short_description ||
//                                   "No description available"}
//                               </p>
//                             </div>
//                           </div>
//                           <div className="product-meta-row">
//                             <div className="price-section">
//                               {/* <span className="current-price">
//                                 {(() => {
//                                   const basePrice = product?.price
//                                     ? Number(product.price)
//                                     : 0;

//                                   // Ensure GST is a number
//                                   const gstValue = product?.gst
//                                     ? Number(product.gst)
//                                     : Number(TAXDocument?.gst || 0);

//                                   // Final price calculation
//                                   const finalPrice =
//                                     !isNaN(gstValue) && gstValue > 0
//                                       ? Math.round(
//                                           basePrice +
//                                             (basePrice * gstValue) / 100
//                                         )
//                                       : basePrice;

//                                   return (
//                                     <>
//                                       {currency.symbol} {finalPrice}
//                                     </>
//                                   );
//                                 })()}
//                               </span> */}

//                               <span className="current-price">
//                                 {productDetailsVisibility &&
//                                   productDetailsVisibility.productPrice && (
//                                     <div className="current-price">
//                                       {(() => {
//                                         const finalPriceWithGST =
//                                           product?.price || 0; // stored price is inclusive of GST
//                                         const gstValue =
//                                           product?.gst !== undefined &&
//                                           product?.gst !== null &&
//                                           product?.gst !== ""
//                                             ? parseFloat(product?.gst)
//                                             : parseFloat(TAXDocument?.gst || 0);

//                                         const hasValidGST =
//                                           !isNaN(gstValue) && gstValue > 0;

//                                         // Reverse calculation: Base Price before GST
//                                         {
//                                           /* const basePrice = hasValidGST
//                       ? Math.round(finalPriceWithGST / (1 + gstValue / 100))
//                       : finalPriceWithGST; */
//                                         }
//                                         return (
//                                           <div className="d-flex align-items-center div-gst-with-price">
//                                             {currencyDoc.symbol}
//                                             {finalPriceWithGST}&nbsp;
//                                           </div>
//                                         );
//                                       })()}
//                                     </div>
//                                   )}
//                               </span>
//                             </div>

//                             <div className="product-rating">
//                               <RatingStars rating={product.rating || 4.5} />
//                             </div>
//                           </div>

//                           <div className="action-buttons">
//                             <div className="action-buttons">
//                               {user ? (
//                                 <>
//                                   {
//                                     pageControlDoc?.cart === true ? ( // ✅ Show cart only if enabled in DB
//                                       isOutOfStock(product) ? (
//                                         <button
//                                           className="card-2-cart-btn out-of-stock"
//                                           disabled
//                                           title="Out of Stock"
//                                         >
//                                           Out of Stock
//                                         </button>
//                                       ) : isProductInCart(product.id) ? (
//                                         <div className="bb-card-2-quantity">
//                                           <button
//                                             className="bb-card-2-btn"
//                                             onClick={(e) => {
//                                               e.stopPropagation();
//                                               const cartItem = findCartItem(
//                                                 product.id
//                                               );
//                                               handleDecrementQuantity(cartItem);
//                                             }}
//                                           >
//                                             -
//                                           </button>
//                                           <input
//                                             type="text"
//                                             value={
//                                               findCartItem(product.id).quantity
//                                             }
//                                             readOnly
//                                           />
//                                           <button
//                                             className="bb-card-2-btn"
//                                             onClick={(e) => {
//                                               e.stopPropagation();
//                                               handleIncrementQuantity(
//                                                 findCartItem(product.id)
//                                               );
//                                             }}
//                                             disabled={
//                                               findCartItem(product.id)
//                                                 .quantity >=
//                                               (product.maxQuantity ||
//                                                 product.stock)
//                                             }
//                                           >
//                                             +
//                                           </button>
//                                         </div>
//                                       ) : (
//                                         <button
//                                           className="bb-card-2-cart-btn"
//                                           onClick={(e) => {
//                                             e.stopPropagation();
//                                             handleAddToCart(product.id);
//                                           }}
//                                           title="Add to Cart"
//                                         >
//                                           <span>Cart</span>
//                                           <span className="material-symbols-outlined">
//                                             shopping_cart
//                                           </span>
//                                         </button>
//                                       )
//                                     ) : null /* Cart disabled in DB → show nothing */
//                                   }
//                                 </>
//                               ) : (
//                                 <Link to="/login">
//                                   {pageControlDoc?.cart === true && ( // ✅ Only show if cart enabled
//                                     <button
//                                       className="bb-card-2-cart-btn"
//                                       title="Add to Cart"
//                                     >
//                                       <span>Cart</span>
//                                       <span className="material-symbols-outlined">
//                                         shopping_cart
//                                       </span>
//                                     </button>
//                                   )}
//                                 </Link>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             )}

//             {isLoading && <PGLoaders />}
//           </div>
//         </div>
//       </div>

//       {/* ADD NEW PRODUCT BUTTON START */}
//       {user && (
//         <>
//           {dbAppTypeDocuments && (
//             <>
//               {/* Lite version: Only SuperAdmin & up to 100 products */}
//               {dbAppTypeDocuments.apptype === "lite" &&
//                 isSuperAdmin &&
//                 products &&
//                 products.length <= 100 && <AddProductsTwo />}

//               {/* Pro version: Unlimited for SuperAdmin & Admin */}
//               {dbAppTypeDocuments.apptype === "pro" &&
//                 (isSuperAdmin || isAdmin) && <AddProductsTwo />}
//             </>
//           )}
//         </>
//       )}
//       {/* ADD NEW PRODUCT BUTTON END */}

//       <CustomSnackbar
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={handleSnackbarClose}
//       />
//     </div>
//   );
// };

// const RatingStars = ({ rating }) => {
//   return (
//     <div className="product-two-rating-stars">
//       <div className="single-star">
//         <FaStar />
//         <span className="rating-number">{rating}</span>
//       </div>
//     </div>
//   );
// };

// export default Productstwo;

import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import "./Productstwo.scss";
import { useCollection } from "../../firebase-files/hooks/useCollection";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import { FaRegHeart, FaStar } from "react-icons/fa";
import {
  IoArrowForward,
  IoArrowBack,
  IoFilter,
  IoClose,
} from "react-icons/io5";
import PriceRangeSlider from "./PriceRangeSlider";
import useCart from "../../firebase-files/hooks/useCart";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import useWishlist from "../../firebase-files/hooks/useWishlist";
import CustomSnackbar from "../CustomSnackbar";
import PGLoaders from "../../default-pages/PGLoaders/PGLoaders";
import AddProductsTwo from "../AddProductsTwo";
import { useNavigate, useSearchParams } from "react-router-dom";
import VendorLocations from "../VendorLocations";

const Productstwo = () => {
  const { user } = useAuthContext();
  const isAdminOrSuperAdmin =
    user?.role === "admin" || user?.role === "superAdmin";

  const navigate = useNavigate();

  const { documents: products } = useCollection("products");
  const { documents: categories } = useCollection("m_categories");

  const { document: currencyDoc } = useDocument("settings", "currency");
  const { document: multiLocation } = useDocument("settings", "multiLocation");
  const { document: productDetailsVisibility } = useDocument(
    "settings",
    "productDetailsVisibility"
  );
  const { document: TAXDocument } = useDocument("settings", "tax_GST");
  const { document: dbAppTypeDocuments } = useDocument("settings", "AppType");

  const { cartItems, addToCart, updateCartItemQuantity } = useCart();
  const { wishlistItems, addToWishlist, removeFromWishlist } = useWishlist();

  const { document: pageControlDoc } = useDocument("settings", "pagesControl");

  const [searchParams, setSearchParams] = useSearchParams();

  const [productsData, setProductsData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [layoutType, setLayoutType] = useState("grid"); // 'grid' or 'list'
  const [activeImageIndexes, setActiveImageIndexes] = useState({});
  const [currency, setCurrency] = useState(currencyDoc);

  // Selected location stored in localStorage (fallback to user if missing)
  const [selectedLocation, setSelectedLocation] = useState(() => {
    return (
      localStorage.getItem("selectedLocation") ||
      user?.selectedLocation ||
      "all"
    );
  });

  // const [filters, setFilters] = useState({
  //   minPrice: "",
  //   maxPrice: "",
  //   selectedCategories: [],
  //   selectedSubCategories: [], // [{ category:'', subcategory:'' }]
  //   sortBy: "default",
  //   selectedRatings: [],
  // });
  const [filters, setFilters] = useState({
    minPrice: "",
    maxPrice: "",
    selectedCategories: [],
    selectedSubCategories: [],
    sortBy: "default",
    selectedRatings: [],
    status: "all", // 👈 NEW (all | active | inactive)
  });

  const [openAccordions, setOpenAccordions] = useState({
    priceRange: true,
    categories: true,
    rating: true,
  });

  // Add a state to trigger price slider reset
  const [resetTrigger, setResetTrigger] = useState(0);

  // Snackbar state
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Infinite scroll pagination
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const PRODUCTS_PER_PAGE = 10;

  // ✅ Helper: Sync filters to URL (IMPORTANT FIX ✅✅)
  const syncFiltersToURL = useCallback(
    (updatedFilters) => {
      const params = new URLSearchParams();

      // Prices
      if (updatedFilters.minPrice !== "" && updatedFilters.minPrice !== null) {
        params.set("minPrice", updatedFilters.minPrice);
      }
      if (updatedFilters.maxPrice !== "" && updatedFilters.maxPrice !== null) {
        params.set("maxPrice", updatedFilters.maxPrice);
      }
      // Status
      if (updatedFilters.status && updatedFilters.status !== "all") {
        params.set("status", updatedFilters.status);
      }

      // Categories
      if (updatedFilters.selectedCategories.length > 0) {
        params.set(
          "category",
          updatedFilters.selectedCategories
            .map((c) => encodeURIComponent(c))
            .join(",")
        );
      }

      // SubCategories
      if (updatedFilters.selectedSubCategories.length > 0) {
        params.set(
          "subcategory",
          updatedFilters.selectedSubCategories
            .map(
              (s) =>
                `${encodeURIComponent(s.category)}|${encodeURIComponent(
                  s.subcategory
                )}`
            )
            .join(",")
        );
      }

      // Rating
      if (updatedFilters.selectedRatings.length > 0) {
        params.set("rating", updatedFilters.selectedRatings.join(","));
      }

      // Sorting
      if (updatedFilters.sortBy && updatedFilters.sortBy !== "default") {
        params.set("sortBy", updatedFilters.sortBy);
      }

      setSearchParams(params);
    },
    [setSearchParams]
  );

  // ✅ Load filters from URL on page load / URL change
  useEffect(() => {
    const params = Object.fromEntries(searchParams.entries());

    const selectedCategoriesFromParams = params.category
      ? params.category
          .split(",")
          .map((c) => decodeURIComponent(c).toLowerCase())
      : [];

    const selectedSubCategoriesFromParams = params.subcategory
      ? params.subcategory.split(",").map((pair) => {
          const parts = pair.split("|");
          const categoryPart = parts[0]
            ? decodeURIComponent(parts[0]).toLowerCase()
            : "";
          const subPart = parts[1]
            ? decodeURIComponent(parts[1]).toLowerCase()
            : decodeURIComponent(parts[0] || "").toLowerCase();

          return { category: categoryPart, subcategory: subPart };
        })
      : [];

    // ensure categories includes ones implied by subcategories
    selectedSubCategoriesFromParams.forEach(({ category }) => {
      if (category && !selectedCategoriesFromParams.includes(category)) {
        selectedCategoriesFromParams.push(category);
      }
    });

    // const newFilters = {
    //   minPrice: params.minPrice || "",
    //   maxPrice: params.maxPrice || "",
    //   selectedCategories: selectedCategoriesFromParams,
    //   selectedSubCategories: selectedSubCategoriesFromParams,
    //   sortBy: params.sortBy || "default",
    //   selectedRatings: params.rating
    //     ? params.rating.split(",").map(Number)
    //     : [],
    // };
    const newFilters = {
      minPrice: params.minPrice || "",
      maxPrice: params.maxPrice || "",
      selectedCategories: selectedCategoriesFromParams,
      selectedSubCategories: selectedSubCategoriesFromParams,
      sortBy: params.sortBy || "default",
      selectedRatings: params.rating
        ? params.rating.split(",").map(Number)
        : [],
      status: params.status || "all", // 👈 NEW
    };

    setFilters(newFilters);
    setPage(1); // ✅ reset pagination when url changes
  }, [searchParams]);

  // ✅ Initialize data
  useEffect(() => {
    if (!products || !categories || !currencyDoc) {
      setLoading(true);
    }
    if (products && categories && currencyDoc) {
      setProductsData(products);
      setCategoriesData(categories);
      setCurrency(currencyDoc);
      setLoading(false);
    }
  }, [products, categories, currencyDoc]);

  // ✅ Keep selectedLocation in sync
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === "selectedLocation") {
        setSelectedLocation(e.newValue);
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    const updateLocation = () => {
      const newLocation = localStorage.getItem("selectedLocation") || "all";
      setSelectedLocation(newLocation);
    };

    window.addEventListener("selectedLocationChanged", updateLocation);

    return () => {
      window.removeEventListener("selectedLocationChanged", updateLocation);
    };
  }, []);

  // ✅ Proper filter change handler (NO overwrite bug)
  const handleFilterChange = useCallback(
    (type, value) => {
      setFilters((prev) => {
        const updated = { ...prev, [type]: value };
        syncFiltersToURL(updated);
        setPage(1); // reset pagination
        return updated;
      });
    },
    [syncFiltersToURL]
  );

  // ✅ FIXED getFilteredProducts
  const getFilteredProducts = () => {
    let filtered = [...productsData];

    // 🔐 ROLE-BASED STATUS FILTER
    // if (!isAdminOrSuperAdmin) {
    //   filtered = filtered.filter((product) => product.status === "active");
    // }
    // 🔐 STATUS FILTER (Admin & User both supported)
    if (!isAdminOrSuperAdmin) {
      // Normal users always see only active products
      filtered = filtered.filter((product) => product.status === "active");
    } else {
      // Admin / SuperAdmin
      if (filters.status === "active") {
        filtered = filtered.filter((product) => product.status === "active");
      }
      if (filters.status === "inactive") {
        filtered = filtered.filter((product) => product.status === "inactive");
      }
    }

    // ⭐ LOCATION FILTER ⭐
    if (multiLocation?.isEnabled === false) {
      return filtered;
    }

    if (selectedLocation !== "all" && multiLocation?.isEnabled === true) {
      filtered = filtered.filter((product) => {
        const showTo = product.showProductTo;
        if (!showTo || showTo.length === 0) return false;
        if (showTo.includes("all")) return true;
        return showTo.includes(selectedLocation);
      });
    }

    // 🔍 Search
    if (searchQuery) {
      filtered = filtered.filter((product) =>
        (product?.name || "").toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // 💰 Price Filter
    if (filters.minPrice !== "") {
      filtered = filtered.filter(
        (product) => Number(product.price) >= Number(filters.minPrice)
      );
    }

    if (filters.maxPrice !== "") {
      filtered = filtered.filter(
        (product) => Number(product.price) <= Number(filters.maxPrice)
      );
    }

    // ✅ Category & Subcategory filter FIXED
    if (
      filters.selectedCategories.length > 0 ||
      filters.selectedSubCategories.length > 0
    ) {
      filtered = filtered.filter((product) => {
        const productCategories = Array.isArray(product.category)
          ? product.category.map((c) => c.toLowerCase())
          : [];

        const productSubCategories = Array.isArray(product.subCategory)
          ? product.subCategory.map((s) => s.toLowerCase())
          : [];

        // category match
        const categoryMatch =
          filters.selectedCategories.length === 0 ||
          productCategories.some((cat) =>
            filters.selectedCategories.includes(cat)
          );

        // subcategory match
        const subCategoryMatch =
          filters.selectedSubCategories.length === 0 ||
          filters.selectedSubCategories.some(({ category, subcategory }) => {
            const subMatch = productSubCategories.includes(subcategory);

            // if filter has category, match category also
            if (category) {
              return subMatch && productCategories.includes(category);
            }

            return subMatch;
          });

        return categoryMatch && subCategoryMatch;
      });
    }

    // ⭐ Rating Filter
    if (filters.selectedRatings.length > 0) {
      filtered = filtered.filter((product) =>
        filters.selectedRatings.some(
          (minRating) => Number(product.rating || 0) >= minRating
        )
      );
    }

    // 🔀 Sorting
    switch (filters.sortBy) {
      case "price-asc":
        filtered.sort((a, b) => Number(a.price) - Number(b.price));
        break;
      case "price-desc":
        filtered.sort((a, b) => Number(b.price) - Number(a.price));
        break;
      default:
        break;
    }

    return filtered;
  };

  const filteredProducts = useMemo(
    () => getFilteredProducts(),
    [
      productsData,
      searchQuery,
      selectedLocation,
      filters.minPrice,
      filters.maxPrice,
      filters.selectedCategories,
      filters.selectedSubCategories,
      filters.selectedRatings,
      filters.sortBy,
      multiLocation?.isEnabled,
      isAdminOrSuperAdmin,
    ]
  );

  const paginatedProducts = useMemo(() => {
    return filteredProducts.slice(0, page * PRODUCTS_PER_PAGE);
  }, [filteredProducts, page]);

  useEffect(() => {
    const totalPages = Math.ceil(filteredProducts.length / PRODUCTS_PER_PAGE);
    setHasMore(page < totalPages);
  }, [filteredProducts.length, page]);

  // Intersection Observer
  const observer = useRef();

  const lastProductRef = useCallback(
    (node) => {
      if (isLoading || !node) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setIsLoading(true);
          setTimeout(() => {
            setPage((prev) => prev + 1);
            setIsLoading(false);
          }, 400);
        }
      });

      observer.current.observe(node);
    },
    [isLoading, hasMore]
  );

  useEffect(() => {
    const currentObserver = observer.current;
    return () => {
      if (currentObserver) currentObserver.disconnect();
    };
  }, []);

  const toggleFilters = () => {
    setShowFilters(!showFilters);
    document.body.style.overflow = !showFilters ? "hidden" : "";
  };

  const toggleAccordion = (section) => {
    setOpenAccordions((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // Cart Helpers
  const isProductInCart = (productId) => {
    return cartItems.some((item) => item.productId === productId);
  };

  const findCartItem = (productId) => {
    return cartItems.find((item) => item.productId === productId);
  };

  const handleAddToCart = async (productId) => {
    try {
      await addToCart(productId);
    } catch (error) {}
  };

  const handleIncrementQuantity = async (cartItem) => {
    try {
      await updateCartItemQuantity(cartItem.id, cartItem.quantity + 1);
    } catch (error) {}
  };

  const handleDecrementQuantity = async (cartItem, removeItem = false) => {
    try {
      if (removeItem || cartItem.quantity <= 1) {
        await updateCartItemQuantity(cartItem.id, 0);
      } else {
        await updateCartItemQuantity(cartItem.id, cartItem.quantity - 1);
      }
    } catch (error) {}
  };

  const isOutOfStock = (product) => {
    return Number(product.stock || 0) <= 0;
  };

  const handleProductCardClick = (productId) => {
    navigate(`/product-details-two/${productId}`);
  };

  // Rating options
  const ratingOptions = [
    { value: 4.5, label: "4.5 & up" },
    { value: 4.0, label: "4.0 & up" },
    { value: 3.0, label: "3.0 & up" },
  ];

  const areFiltersActive = () => {
    return (
      filters.minPrice !== "" ||
      filters.maxPrice !== "" ||
      filters.selectedCategories.length > 0 ||
      filters.selectedSubCategories.length > 0 ||
      filters.selectedRatings.length > 0 ||
      filters.sortBy !== "default"
    );
  };

  const handleResetFilters = () => {
    const reset = {
      minPrice: "",
      maxPrice: "",
      selectedCategories: [],
      selectedSubCategories: [],
      sortBy: "default",
      selectedRatings: [],
      status: "all", // 👈 add
    };

    setFilters(reset);
    setPage(1);
    setResetTrigger((prev) => prev + 1);
    setSearchParams({});
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  // Wishlist
  const isProductInWishlist = (productId) => {
    return wishlistItems.some((item) => item.productId === productId);
  };

  const handleToggleWishlist = async (e, productId) => {
    e.stopPropagation();
    if (!user) {
      setSnackbar({
        open: true,
        message: "Please login to add items to wishlist.",
        severity: "info",
      });
      return;
    }

    if (isProductInWishlist(productId)) {
      const wishlistItem = wishlistItems.find(
        (item) => item.productId === productId
      );
      await removeFromWishlist(wishlistItem.id);
      setSnackbar({
        open: true,
        message: "Product removed from wishlist!",
        severity: "success",
      });
    } else {
      await addToWishlist(productId);
      setSnackbar({
        open: true,
        message: "Product added to wishlist!",
        severity: "success",
      });
    }
  };

  const nextImage = (productId, totalImages) => {
    setActiveImageIndexes((prev) => ({
      ...prev,
      [productId]: ((prev[productId] || 0) + 1) % totalImages,
    }));
  };

  const prevImage = (productId, totalImages) => {
    setActiveImageIndexes((prev) => ({
      ...prev,
      [productId]: ((prev[productId] || 0) - 1 + totalImages) % totalImages,
    }));
  };

  if (loading) return <div className="loading"></div>;

  return (
    <div className="products-two-container">
      {/* overlay */}
      <div
        className={`drawer-overlay ${showFilters ? "show" : ""}`}
        onClick={toggleFilters}
      ></div>

      <div className="two-column-layout">
        {/* Left Filters */}
        <aside className={`filters-column ${showFilters ? "show" : ""}`}>
          <div className="filters-header">
            <div className="filters-title-reset">
              <h3>Filters</h3>

              {areFiltersActive() && (
                <button
                  className="reset-product-two-filters-btn"
                  onClick={handleResetFilters}
                  title="Reset all filters"
                >
                  Reset
                </button>
              )}
            </div>

            <button
              className="close-filters"
              onClick={toggleFilters}
              aria-label="Close filters"
            >
              <span className="material-symbols-outlined">
                <IoClose />
              </span>
            </button>
          </div>

          <div className="filters-content">
            {/* Status Filter (Admin only) */}
            {isAdminOrSuperAdmin && (
              <div className="filter-section status-filter">
                <div className="status-buttons">
                  <button
                    className={`status-btn ${
                      filters.status === "active" ? "active" : ""
                    }`}
                    onClick={() => handleFilterChange("status", "active")}
                  >
                    Active
                  </button>

                  <button
                    className={`status-btn ${
                      filters.status === "inactive" ? "active" : ""
                    }`}
                    onClick={() => handleFilterChange("status", "inactive")}
                  >
                    Inactive
                  </button>

                  <button
                    className={`status-btn ${
                      filters.status === "all" ? "active" : ""
                    }`}
                    onClick={() => handleFilterChange("status", "all")}
                  >
                    All
                  </button>
                </div>
              </div>
            )}

            {/* Price Range */}
            <div className="filter-section">
              <div
                className={`accordion-header ${
                  openAccordions.priceRange ? "open" : ""
                }`}
                onClick={() => toggleAccordion("priceRange")}
              >
                <h3>Price Range</h3>
                <span className="material-symbols-outlined">expand_more</span>
              </div>

              <div
                className={`accordion-content ${
                  openAccordions.priceRange ? "open" : ""
                }`}
              >
                <PriceRangeSlider
                  minPrice={filters.minPrice}
                  maxPrice={filters.maxPrice}
                  onChange={({ min, max }) => {
                    // ✅ FIX: single update in one setFilters
                    setFilters((prev) => {
                      const updated = { ...prev, minPrice: min, maxPrice: max };
                      syncFiltersToURL(updated);
                      setPage(1);
                      return updated;
                    });
                  }}
                  currency={currency}
                  resetTrigger={resetTrigger}
                />
              </div>
            </div>

            <hr />

            {/* Category & Subcategory */}
            <div className="filter-section">
              <div
                className={`accordion-header ${
                  openAccordions.categories ? "open" : ""
                }`}
                onClick={() => toggleAccordion("categories")}
              >
                <h3>Categories</h3>
                <span className="material-symbols-outlined">
                  {openAccordions.categories ? "expand_less" : "expand_more"}
                </span>
              </div>

              <div
                className={`accordion-content ${
                  openAccordions.categories ? "open" : ""
                }`}
              >
                {categoriesData
                  .filter(
                    (category) =>
                      category.status === "active" &&
                      category.source?.toLowerCase() !== "faq"
                  )
                  .map((category) => {
                    const catName = category.category.toLowerCase();

                    return (
                      <div
                        key={category.category}
                        className="product-two-category-item"
                      >
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            checked={filters.selectedCategories.includes(
                              catName
                            )}
                            onChange={(e) => {
                              const checked = e.target.checked;

                              setFilters((prev) => {
                                const newCategories = checked
                                  ? [...prev.selectedCategories, catName]
                                  : prev.selectedCategories.filter(
                                      (c) => c !== catName
                                    );

                                // ✅ if category unchecked -> remove all its subcategories
                                const newSubCategories = checked
                                  ? prev.selectedSubCategories
                                  : prev.selectedSubCategories.filter(
                                      (s) => s.category !== catName
                                    );

                                const updated = {
                                  ...prev,
                                  selectedCategories: newCategories,
                                  selectedSubCategories: newSubCategories,
                                };

                                syncFiltersToURL(updated);
                                setPage(1);
                                return updated;
                              });
                            }}
                          />
                          <span className="product-two-category-name">
                            {category.category}
                          </span>
                        </label>

                        {/* Subcategories only when category selected */}
                        {filters.selectedCategories.includes(catName) &&
                          category.subCategories &&
                          category.subCategories
                            .filter(
                              (sub) =>
                                sub.status === "active" &&
                                sub.source?.toLowerCase() !== "faq"
                            )
                            .map((subcategory) => {
                              const subName =
                                subcategory.subCategoryName.toLowerCase();

                              const checked =
                                filters.selectedSubCategories.some(
                                  (x) =>
                                    x.category === catName &&
                                    x.subcategory === subName
                                );

                              return (
                                <label
                                  key={subcategory.subCategoryName}
                                  className="checkbox-label subcategory-label subcategories-list"
                                >
                                  <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;

                                      setFilters((prev) => {
                                        const newSubCategories = isChecked
                                          ? [
                                              ...prev.selectedSubCategories,
                                              {
                                                category: catName,
                                                subcategory: subName,
                                              },
                                            ]
                                          : prev.selectedSubCategories.filter(
                                              (x) =>
                                                !(
                                                  x.category === catName &&
                                                  x.subcategory === subName
                                                )
                                            );

                                        const updated = {
                                          ...prev,
                                          selectedSubCategories:
                                            newSubCategories,
                                        };

                                        syncFiltersToURL(updated);
                                        setPage(1);
                                        return updated;
                                      });
                                    }}
                                  />
                                  <span className="product-two-subcategory-name">
                                    {subcategory.subCategoryName}
                                  </span>
                                </label>
                              );
                            })}
                      </div>
                    );
                  })}
              </div>
            </div>

            <hr />

            {/* Rating */}
            <div className="filter-section">
              <div
                className={`accordion-header ${
                  openAccordions.rating ? "open" : ""
                }`}
                onClick={() => toggleAccordion("rating")}
              >
                <h3>Rating</h3>
                <span className="material-symbols-outlined">
                  {openAccordions.rating ? "expand_less" : "expand_more"}
                </span>
              </div>

              <div
                className={`accordion-content ${
                  openAccordions.rating ? "open" : ""
                }`}
              >
                <div className="rating-section">
                  {ratingOptions.map((option) => (
                    <label key={option.value} className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={filters.selectedRatings.includes(option.value)}
                        onChange={(e) => {
                          const newRatings = e.target.checked
                            ? [...filters.selectedRatings, option.value]
                            : filters.selectedRatings.filter(
                                (r) => r !== option.value
                              );
                          handleFilterChange("selectedRatings", newRatings);
                        }}
                      />
                      <div className="rating-label">
                        <span>{option.label}</span>
                        <div className="stars">
                          {[...Array(5)].map((_, index) => (
                            <FaStar
                              key={index}
                              className={
                                index + 1 <= option.value ? "filled" : "empty"
                              }
                            />
                          ))}
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <hr className="filter-divider" />
          </div>
        </aside>

        {/* Right Column */}
        <div className="bb-main-column">
          <div className="bb-products-section">
            <div className="bb-products-header">
              <VendorLocations />

              <div className="view-options">
                <button
                  className="filter-toggle"
                  onClick={toggleFilters}
                  aria-label="Toggle filters"
                >
                  <IoFilter />
                </button>
              </div>

              <div className="sort-section">
                <select
                  value={filters.sortBy}
                  onChange={(e) => handleFilterChange("sortBy", e.target.value)}
                >
                  <option value="default">Sort By</option>
                  <option value="price-asc">Price: Low to High</option>
                  <option value="price-desc">Price: High to Low</option>
                </select>
              </div>
            </div>

            {filteredProducts.length === 0 ? (
              <div className="bb-no-products">
                <span className="material-symbols-outlined">inventory_2</span>
                <h3>No Products Found</h3>
                <p>Try adjusting your filters or search criteria</p>
              </div>
            ) : (
              <div className={`product-two-products-container ${layoutType}`}>
                {paginatedProducts.map((product, index) => {
                  const isLastProduct = index === paginatedProducts.length - 1;

                  return (
                    <div
                      ref={isLastProduct ? lastProductRef : null}
                      key={product.id}
                      className="product-card"
                    >
                      <div
                        className="card-clickable-overlay"
                        onClick={() => handleProductCardClick(product.id)}
                      ></div>

                      <div className="product-image-container">
                        <div className="image-carousel">
                          {product.images && product.images.length > 0 && (
                            <img
                              src={(() => {
                                const imgs = product.images;
                                if (!imgs) return "";

                                if (Array.isArray(imgs)) {
                                  const img =
                                    imgs[activeImageIndexes[product.id] || 0];
                                  return typeof img === "string"
                                    ? img
                                    : img?.url || "";
                                }

                                if (typeof imgs === "string") return imgs;

                                if (typeof imgs === "object" && imgs.url)
                                  return imgs.url;

                                return "";
                              })()}
                              alt={product.name}
                            />
                          )}

                          {product.images && product.images.length > 1 && (
                            <>
                              <button
                                className="carousel-btn prev"
                                onClick={(e) => {
                                  e.preventDefault();
                                  prevImage(product.id, product.images.length);
                                }}
                              >
                                <IoArrowBack />
                              </button>
                              <button
                                className="carousel-btn next"
                                onClick={(e) => {
                                  e.preventDefault();
                                  nextImage(product.id, product.images.length);
                                }}
                              >
                                <IoArrowForward />
                              </button>
                            </>
                          )}
                        </div>

                        <button
                          className={`wishlist-btn ${
                            isProductInWishlist(product.id) ? "active" : ""
                          }`}
                          onClick={(e) => handleToggleWishlist(e, product.id)}
                        >
                          <FaRegHeart />
                        </button>

                        {product.discount > 0 && (
                          <div className="discount-badge">
                            {product.discount}%
                          </div>
                        )}
                      </div>

                      <div className="product-details">
                        <div className="product-info">
                          <div className="product-header">
                            <div className="product-category">
                              {(product.category || []).join(" | ")} |&nbsp;
                              {(product.subCategory || []).join(" | ")}
                            </div>

                            <h3 className="product-name">{product.name}</h3>

                            <div className="product-description">
                              <p>
                                {product.short_description ||
                                  "No description available"}
                              </p>
                            </div>
                          </div>

                          <div className="product-meta-row">
                            <div className="price-section">
                              <span className="current-price">
                                {productDetailsVisibility &&
                                  productDetailsVisibility.productPrice && (
                                    <div className="current-price">
                                      <div className="d-flex align-items-center div-gst-with-price">
                                        {currencyDoc?.symbol}
                                        {product?.price || 0}&nbsp;
                                      </div>
                                    </div>
                                  )}
                              </span>
                            </div>

                            <div className="product-rating">
                              <RatingStars rating={product.rating || 4.5} />
                            </div>
                          </div>

                          <div className="action-buttons">
                            {user ? (
                              <>
                                {pageControlDoc?.cart === true ? (
                                  isOutOfStock(product) ? (
                                    <button
                                      className="card-2-cart-btn out-of-stock"
                                      disabled
                                      title="Out of Stock"
                                    >
                                      Out of Stock
                                    </button>
                                  ) : isProductInCart(product.id) ? (
                                    <div className="bb-card-2-quantity">
                                      <button
                                        className="bb-card-2-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const cartItem = findCartItem(
                                            product.id
                                          );
                                          handleDecrementQuantity(cartItem);
                                        }}
                                      >
                                        -
                                      </button>

                                      <input
                                        type="text"
                                        value={
                                          findCartItem(product.id)?.quantity
                                        }
                                        readOnly
                                      />

                                      <button
                                        className="bb-card-2-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleIncrementQuantity(
                                            findCartItem(product.id)
                                          );
                                        }}
                                        disabled={
                                          findCartItem(product.id)?.quantity >=
                                          (product.maxQuantity || product.stock)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  ) : (
                                    <button
                                      className="bb-card-2-cart-btn"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleAddToCart(product.id);
                                      }}
                                      title="Add to Cart"
                                    >
                                      <span>Cart</span>
                                      <span className="material-symbols-outlined">
                                        shopping_cart
                                      </span>
                                    </button>
                                  )
                                ) : null}
                              </>
                            ) : (
                              <Link to="/login">
                                {pageControlDoc?.cart === true && (
                                  <button
                                    className="bb-card-2-cart-btn"
                                    title="Add to Cart"
                                  >
                                    <span>Cart</span>
                                    <span className="material-symbols-outlined">
                                      shopping_cart
                                    </span>
                                  </button>
                                )}
                              </Link>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {isLoading && <PGLoaders />}
          </div>
        </div>
      </div>

      {/* ADD NEW PRODUCT BUTTON */}
      {user && (
        <>
          {dbAppTypeDocuments && (
            <>
              {dbAppTypeDocuments.apptype === "lite" &&
                user?.role === "superAdmin" &&
                products &&
                products.length <= 100 && <AddProductsTwo />}

              {dbAppTypeDocuments.apptype === "pro" &&
                (user?.role === "superAdmin" || user?.role === "admin") && (
                  <AddProductsTwo />
                )}
            </>
          )}
        </>
      )}

      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleSnackbarClose}
      />
    </div>
  );
};

const RatingStars = ({ rating }) => {
  return (
    <div className="product-two-rating-stars">
      <div className="single-star">
        <FaStar />
        <span className="rating-number">{rating}</span>
      </div>
    </div>
  );
};

export default Productstwo;
